import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "assign-thermostat-shared-actuator" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AddDeviceToLinkableObject = _resolveComponent("AddDeviceToLinkableObject")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_AddDeviceToLinkableObject, {
      currentDevices: _ctx.currentDevicesSharedActuators,
      assignableDevices: _ctx.devicesSharedActuators,
      linkableObject: _ctx.roomObject,
      deleteUnusedDevices: true,
      addToastMessage: _ctx.$t('assignThermo.sharedActuatorAdded'),
      ruleServiceType: _ctx.SlotRuleServiceType.THERMO_SHARED_ACTUATORS
    }, null, 8, ["currentDevices", "assignableDevices", "linkableObject", "addToastMessage", "ruleServiceType"])
  ]))
}